import { isRecord } from '@logistiek-zonder-papier/lzp-library'

export function emptyToNull(value: unknown) {
  if (value === '') {
    return null
  }

  if (isRecord(value)) {
    for (const [key, entry] of Object.entries(value)) {
      value[key] = emptyToNull(entry)
    }
  } else if (Array.isArray(value)) {
    for (let index = 0; index < value.length; index++) {
      value[index] = emptyToNull(value)
    }
  }
  return value
}
